import React, { useEffect, useState } from 'react';
import { Button, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { SimpleModal } from 'components/Modal';

type Props = {
  open: boolean;
  onSave: (value: string) => Promise<void> | void;
  saving?: boolean;
  initialValue?: string | null;
};

const OPTIONS = [
  { value: 'scent-free', label: 'Scent-free', description: 'Fragrance-free products and policy enforced' },
  { value: 'not-scent-free', label: 'Not scent-free', description: 'Fragrances may be present in the office' },
];

export const ScentFreePolicyModal: React.FC<Props> = ({ open, onSave, saving = false, initialValue }) => {
  const [value, setValue] = useState<string>(initialValue || '');

  useEffect(() => {
    if (open) {
      setValue(initialValue || '');
    }
  }, [open, initialValue]);

  return (
    <SimpleModal isOpen={open} onClose={() => {}}>
      <div style={{ padding: 24, maxWidth: 520 }}>
        <h2 style={{ marginBottom: 8 }}>Quick Question About Your Office</h2>
        <p style={{ margin: '0 0 16px', lineHeight: 1.5 }}>
          We&apos;ve been getting questions about scent-free environments. This is important to a growing
          number of dental professionals. Please indicate your office&apos;s policy on this so we can ensure
          you find the best matches for your shifts.
        </p>

        <RadioGroup
          value={value}
          onChange={(e) => setValue(e.target.value)}
        >
          {OPTIONS.map(option => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio color="primary" />}
              label={
                <div>
                  <div style={{ fontWeight: 600 }}>{option.label}</div>
                  <div style={{ fontSize: '0.9em', opacity: 0.8 }}>{option.description}</div>
                </div>
              }
              style={{ marginBottom: 12, alignItems: 'flex-start' }}
            />
          ))}
        </RadioGroup>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          size="large"
          disabled={!value || saving}
          onClick={() => onSave(value)}
          style={{ marginTop: 12 }}
        >
          {saving ? 'Saving…' : 'Save'}
        </Button>
      </div>
    </SimpleModal>
  );
};

